import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { HttpResponse } from "@angular/common/http";
import { PartnerService } from "../partner.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
// import Swal from "sweetalert2";
@Component({
  selector: 'app-add-partner',
  templateUrl: './add-partner.component.html',
  styleUrls: ['./add-partner.component.css']
})
export class AddPartnerComponent implements OnInit {

  partnerForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: PartnerService
  ) { }

  ngOnInit() {
    this.initialiseForms();
    this.partnerForm.reset();
  }



  initialiseForms() {
    this.partnerForm = this.fb.group({
      name: ["", [Validators.required]],
      companyName: ["", [Validators.required]],
      mobile: ["", [Validators]],
      email:["", [Validators.required, Validators.pattern(this.emailPattern)]],
      address: [""],

    });
  }


  Addplan() {
    this.formSubmitted = true;
    if (this.partnerForm.valid) {
      let request = this.partnerForm.value;
       request['mobile'] = request['mobile'].toString();
       if (request['address'] == '' || request['address'] == null ) {
         delete request['address']
       }
      this.PlanService.saveplan(request).subscribe(data => {
        if ((data["status"] = "Success")) {
          Swal.fire("Success", "Partner Added successfully!", "success");
          this.router.navigate(["/main/partner/view"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }




  }

  cancel() {
    this.router.navigate(["/main/partner/view"]);
  }
}


